import React from 'react';
import PropTypes from 'prop-types';

/**
 * BreadcrumbItem - A wrapper that renders a standard HTML li element with Bulma breadcrumb item styling
 * 
 * This component accepts the same props as Bloomer BreadcrumbItem for easy migration
 */
const BreadcrumbItem = ({
  className,
  style,
  isActive,
  children,
  ...props
}) => {
  // Build the class names based on props
  const getClassNames = () => {
    const classes = [];
    
    // Add active class
    if (isActive) {
      classes.push('is-active');
    }
    
    // Add custom class names
    if (className) {
      classes.push(className);
    }
    
    return classes.join(' ');
  };

  return (
    <li 
      className={getClassNames()} 
      style={style}
      {...props}
    >
      {children}
    </li>
  );
};

BreadcrumbItem.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  isActive: PropTypes.bool,
  children: PropTypes.node
};

BreadcrumbItem.defaultProps = {
  className: '',
  style: {},
  isActive: false,
  children: null
};

export default BreadcrumbItem;
